import {
  fetchDispensaryMenu as fetchInner,
} from "@the-drop/customer-shared/api/dispensary-menu";
import { getCustomerApiBaseUrl } from "./api-base";

export function fetchDispensaryMenu(slug: string) {
  return fetchInner(getCustomerApiBaseUrl(), slug);
}

export {
  DispensaryMenuNotFoundError,
  DispensaryMenuHttpError,
} from "@the-drop/customer-shared/api/dispensary-menu";
